import { render, staticRenderFns } from "./BlogDisqus.vue?vue&type=template&id=51d946f1&lang=pug"
import script from "./BlogDisqus.vue?vue&type=script&lang=js"
export * from "./BlogDisqus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports